import { Helmet } from 'react-helmet-async';
import {
  Grid,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from '@mui/material';
import { Navigate } from 'react-router-dom';
import * as React from 'react';
import { useState, useEffect } from 'react';
import API from '../../api';

import { DefaultContainedButton } from '../../utils/Buttons';

// sections
import { AppCalendar, AppLastUsers, AppSurvey } from '../../sections/app';
import { LoadingUI } from '../../utils/LayoutStyles';

// ----------------------------------------------------------------------

export default function DashboardAdmin() {
  const [currentProfile, setCurrentProfile] = useState('');
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    setUserInfo(userData);
    const roles = userData.roles;
    const currentRole = roles.filter((role) => role.last_used === 1);
    setCurrentProfile(currentRole);
    checkAdminDisciplinary(userData.id);
  }, []);

  /* ------------------------------ Disciplinary ------------------------------ */

  const [disciplinaryDialogOpen, setDisciplinaryDialogOpen] = useState(false);
  const [checkedAdminDisciplinary, setCheckedAdminDisciplinary] = useState(false);
  const [adminPolicyApiCalled, setAdminPolicyApiCalled] = useState(false);
  const [disciplinary, setDisciplinary] = useState({});
  const [openedByButton, setOpenedByButton] = useState(false);
  const [policyNotFound, setPolicyNotFound] = useState(false)

  const checkAdminDisciplinary = (userID) => {
    API.get(`/admin_policy`, {
      params: {
        user_id: userID,
      },
    }).then((response) => {
      if (!response.data.relation_exists) {
        setDisciplinaryDialogOpen(true);
        setCheckedAdminDisciplinary(true);
        setOpenedByButton(false);
      }
      setAdminPolicyApiCalled(true);
    }).catch((error) => {
      if(error.status === 403){
        setPolicyNotFound(true)
      }
    });
  };

  useEffect(() => {
    if (disciplinaryDialogOpen && checkedAdminDisciplinary) {
      getLastDisciplinary();
    }
  }, [disciplinaryDialogOpen, checkedAdminDisciplinary]);

  const getLastDisciplinary = () => {
    if (Object.keys(disciplinary).length === 0) {
      API.get(`last_disciplinary`).then((response) => {
        setDisciplinary(response.data);
      });
    }
  };

  const acceptDisciplinary = () => {
    const data = {
      user_id: userInfo.id,
      policy_id: disciplinary.id,
    };

    API.post(`/admin_policy`, data).then((response) => {
      setDisciplinaryDialogOpen(false);
    });
  };

  const handleCloseDisciplinary = () => {
    setDisciplinaryDialogOpen(false);

    setTimeout(() => {
      setOpenedByButton(false);
    }, 300);
  };

  const openDialogFromButton = () => {
    setOpenedByButton(true);
    getLastDisciplinary();
    setDisciplinaryDialogOpen(true);
  };

  // const profile = 'admin';

  if (currentProfile && currentProfile[0].prof_type_name !== 'ADMIN') return <Navigate to={{ pathname: '/' }} />;

  return (
    <>
      <Helmet>
        <title>Dashboard Amministratore</title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AppLastUsers />
          </Grid>

          <Grid item xs={12} md={6}>
            <AppCalendar title="Calendario Eventi" isAdmin={1} />
          </Grid>

          <Grid item xs={12} md={3}>
            <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CardHeader title="Disciplinare Amministratori" />
              <CardContent sx={{ padding: '0 24px', paddingBottom: '0', paddingTop: '24px' }}>
                <DefaultContainedButton
                  customStyles={{ margin: '0' }}
                  disabled={!adminPolicyApiCalled && policyNotFound}
                  onClick={() => {
                    openDialogFromButton();
                  }}
                >
                  Visualizza
                </DefaultContainedButton>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={12} md={7}>
            <AppSurvey profile={profile} />
          </Grid> */}

          <Dialog open={disciplinaryDialogOpen} onClose={() => {}} fullWidth maxWidth="lg">
            <DialogTitle>Disciplinare d'uso della Piattaforma HUB</DialogTitle>
            <DialogContent>
              {Object.keys(disciplinary).length > 0 ? (
                <Typography variant="p">
                  <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{disciplinary.description}</pre>
                </Typography>
              ) : (
                LoadingUI()
              )}
            </DialogContent>
            <DialogActions>
              {openedByButton ? (
                <DefaultContainedButton
                  onClick={() => {
                    handleCloseDisciplinary();
                  }}
                >
                  Chiudi
                </DefaultContainedButton>
              ) : (
                <>
                  <DefaultContainedButton onClick={acceptDisciplinary}>Accetta</DefaultContainedButton>
                </>
              )}
            </DialogActions>
          </Dialog>
        </Grid>
      </Container>
    </>
  );
}
